import Controller from '@ember/controller';

export default class SiteBillingInsuranceShowController extends Controller {}
